import * as React from "react"

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import { Link, useLocation } from "react-router-dom"
import { data } from "@/constants/sidebar"
import { useQueryParams } from "@/hooks/use-query-params"
import { usePermissions } from "@/providers/permission-provider"
import {
  handleToggleSidebar,
  isLinkActive,
} from "@/utils/sidebar"

export const PortalReportsSidebarMenu = () => {
  const { toggleSidebar, isMobile } = useSidebar()
  const location = useLocation()
  const pathname = location.pathname
  const queryParams = useQueryParams()
  const brokerId = queryParams.brokerId
  const { hasPermission } = usePermissions()

  return (
    <SidebarMenu>
      {data.reportsLinks.map((link) => {
        if (!hasPermission(link.permissionRoles)) {
          return null
        }

        const getUrlWithBrokerId = () => {
          if (!brokerId) return link.url

          const separator = link.url.includes("?")
            ? "&"
            : "?"
          return `${link.url}${separator}brokerId=${brokerId}`
        }

        return (
          <SidebarMenu key={link.url}>
            <SidebarMenuItem>
              <SidebarMenuButton
                asChild
                tooltip={link.tooltip}
                isActive={isLinkActive(
                  link.url,
                  link.mainPath,
                  pathname
                )}
                onClick={() =>
                  handleToggleSidebar(
                    isMobile,
                    toggleSidebar
                  )
                }
              >
                <Link to={getUrlWithBrokerId()}>
                  <link.icon />
                  <span>{link.label}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        )
      })}
    </SidebarMenu>
  )
}
